// @flow

import { Record } from "immutable"
import type { AuthToken } from "@kiwicom/nitro/lib/records/Auth"

import type { GetState } from "../../../types/state"

const SMART_FAQ_TOGGLE = "smartFAQ/SMART_FAQ_TOGGLE"
const HIDE_BELOW_MODALS = "smartFAQ/HIDE_BELOW_MODALS"

export type HelpArticle = {|
  id: number,
|}

// See DOCs: https://gitlab.skypicker.com/frontend/smart-faq/blob/master/README.md#links-to-a-specific-article
export const articles: { [string]: HelpArticle } = {
  BLUE_RIBBON_BAGS_ARTICLE: {
    id: 179,
  },
  FAST_TRACK_BGY_ARTICLE: {
    id: 181,
  },
  FAST_TRACK_NCE_ARTICLE: {
    id: 191,
  },
  INCORRECT_TRAVEL_DETAILS: {
    id: 77,
  },
  TRAINS_ARTICLE: {
    id: 127,
  },
  PRIORITY_BOARDING_ARTICLE: {
    id: 129,
  },
  DISABLED_BAGS_IN_MMB_ARTICLE: {
    id: 133,
  },
  THROW_AWAY_TICKET_ARTICLE: {
    id: 135,
  },
  KIWI_COM_GUARANTEE: {
    id: 146,
  },
  AIRLINE_GUARANTEE: {
    id: 134,
  },
  DISALLOWED_BAGS_ARTICLE: {
    id: 50,
  },
  RECHECK_BAGGAGE: {
    id: 47,
  },
  CANCEL_BOOKING: {
    id: 78,
  },
  CABIN_BAGGAGE: {
    id: 41,
  },
  PERSONAL_ITEM: {
    id: 42,
  },
  CHECKED_BAGGAGE: {
    id: 43,
  },
  USA_CUBA: {
    id: 123,
  },
  METASEARCH: {
    id: 139,
  },
  SELF_TRANSFER: {
    id: 68,
  },
  RELEASE_NEWS: {
    id: 0, // not defined
  },
  REFUND_HOW_LONG: {
    id: 79,
  },
  PRIMERA_BANKRUPTCY: {
    id: 172,
  },
  AIR_HELP: {
    id: 169,
  },
  COBALT_BANKRUPTCY: {
    id: 175,
  },
  TRAVEL_INSURANCE: {
    id: 9,
  },
  SERVICE_PACKAGES: {
    id: 178,
  },
  PRIORITY_LINE: {
    id: 180,
  },
  WOWAIR_BANKRUPTCY: {
    id: 184,
  },
  JETAIR_BANKRUPTCY: {
    id: 188,
  },
  AIGLE_AZUR_BANKRUPTCY: {
    id: 198,
  },
  KIWI_COM_CREDIT: {
    id: 17,
  },
  AIRPORT_CHECKIN: {
    id: 57,
  },
  ONLINE_CHECKIN: {
    id: 108,
  },
  RYANAIR_MANDATORY_SEATING: {
    id: 174,
  },
  INVOICES_ARTICLE: {
    id: 121,
  },
  MEALS_ARTICLE: {
    id: 3,
  },
  SPECIAL_ASSISTANCE: {
    id: 2,
  },
  MUSIC_AND_SPORT_EQUIPMENT: {
    id: 144,
  },
  PET_PASSENGERS: {
    id: 141,
  },
  REFUNDS_AND_CANCELLATIONS: {
    id: 155,
  },
  BAGGAGE_BUNDLES: {
    id: 194,
  },
  BOOKING_CONFIRMATION: {
    id: 162,
  },
}

const Article = Record({
  id: null,
})

const DefaultWidgetState = Record({
  open: false,
  article: null,
})

const SmartFAQState = Record({
  widget: new DefaultWidgetState(),
  hideBelowModals: false,
})

export function toggleSmartFAQ(open: boolean, article: ?HelpArticle) {
  return {
    type: SMART_FAQ_TOGGLE,
    open,
    article,
  }
}

export function hideBelowModals(hide: boolean) {
  return {
    type: HIDE_BELOW_MODALS,
    hide,
  }
}

export function handleSimpleToken(tokenInfo: AuthToken) {
  return (dispatch: Dispatch<*>, getState: GetState) => {
    const { bid, token } = tokenInfo
    const state = getState()
    const disableMmbRedirection = state.modals.hasIn(["login", "disableMmbRedirection"])

    if (!disableMmbRedirection) {
      const lang = state.options.get("language")

      window.location = `/${lang}/manage/${bid}/${token}`
    }
  }
}

const toggleHelp = (open: boolean, article: ?HelpArticle) => (dispatch: Dispatch<*>) => {
  dispatch(toggleSmartFAQ(open, article))
}

export const openHelp = (article: ?HelpArticle) => toggleHelp(true, article)
export const closeHelp = () => toggleHelp(false)

export default function(state: Record<*> = new SmartFAQState(), action: any) {
  if (!(state instanceof SmartFAQState)) {
    return new SmartFAQState()
  }

  switch (action.type) {
    case SMART_FAQ_TOGGLE:
      return state.mergeIn(["widget"], {
        open: action.open,
        article: action.open && action.article ? new Article(action.article) : null,
      })
    case HIDE_BELOW_MODALS:
      return state.set("hideBelowModals", action.hide)

    default:
      return state
  }
}
